export default __webpack_public_path__ + "static/media/3.aea7b822.webp";